import React, { type ReactNode, useRef, useState } from 'react';

import { Link } from 'react-router-dom';

import { CollectionPeek } from '@pkg/components/Collections/CollectionPeek';
import { type Collection } from '@pkg/graphql/codegen/graphql';
import { useBreakpoints } from '@pkg/hooks';
import { type SupportedChain } from '@pkg/types';

export interface CollectionLinkProps {
    children: ReactNode;
    slug?: string;
    disablePeek?: boolean;
    chain?: SupportedChain;
    collectionData?: Partial<Collection> | null;
}

export function CollectionLink({
    children,
    slug = '',
    disablePeek = false,
    chain,
    collectionData,
}: CollectionLinkProps) {
    const { isMobile } = useBreakpoints();

    const [isHovered, setIsHovered] = useState(false);
    const ref = useRef<HTMLAnchorElement>(null);

    function handleMouseOver() {
        setIsHovered(true);
    }

    function handleMouseOut() {
        setIsHovered(false);
    }

    const linkTo = chain ? `/collection/${chain}/${slug}` : undefined;

    return (
        <>
            {linkTo ? (
                <Link
                    style={{ cursor: 'pointer' }}
                    ref={ref}
                    onMouseEnter={handleMouseOver}
                    onMouseLeave={handleMouseOut}
                    onClick={(e) => e.stopPropagation()}
                    to={linkTo}
                >
                    {children}
                </Link>
            ) : (
                children
            )}

            {!isMobile && !disablePeek ? (
                <CollectionPeek slug={slug} hovered={isHovered} linkElement={ref} collectionData={collectionData} />
            ) : null}
        </>
    );
}
